var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Absolute, Text, CloseButton } from 'pcln-design-system';
import styled, { keyframes } from 'styled-components';
var NotificationBox = styled(Absolute)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  border-radius: 6px 12px 20px 24px;\n  cursor: pointer;\n"], ["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  border-radius: 6px 12px 20px 24px;\n  cursor: pointer;\n"])));
var fadeInFromBottomToTopLeftAnimation = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\nfrom {\n     transform: translate(100px, 150px);\n    -webkit-transform: translate(100px, 150px);\n     opacity: 0; \n  }\n\n  to {\n     transform: translate(0px, 0px);\n     opacity: 1; \n  }\n"], ["\nfrom {\n     transform: translate(100px, 150px);\n    -webkit-transform: translate(100px, 150px);\n     opacity: 0; \n  }\n\n  to {\n     transform: translate(0px, 0px);\n     opacity: 1; \n  }\n"])));
var AnimatedElement = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0px;\n  animation: ", " 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  bottom: 0px;\n  animation: ", " 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n  width: 100%;\n  height: 100%;\n"
    /**
     * ChatBotPopOver
     * chat notification popover
     * @public
     */
])), fadeInFromBottomToTopLeftAnimation);
/**
 * ChatBotPopOver
 * chat notification popover
 * @public
 */
export function ChatBotPopOver(props) {
    var onClose = props.onClose, onOpen = props.onOpen, text = props.text, positionProps = props.positionProps, containerProps = props.containerProps;
    var _a = positionProps !== null && positionProps !== void 0 ? positionProps : {}, zIndex = _a.zIndex, bottom = _a.bottom, right = _a.right;
    var _b = (containerProps !== null && containerProps !== void 0 ? containerProps : {}).width, width = _b === void 0 ? '300px' : _b;
    return (React.createElement(AnimatedElement, null,
        React.createElement(NotificationBox, { pt: 3, pb: 3, px: 3, bottom: bottom, right: right, zIndex: zIndex, width: width, boxShadow: 'lg', background: 'background.lightest', color: 'text.base', onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                onOpen();
            } },
            React.createElement(Absolute, { bottom: '55px', right: '-10px' },
                React.createElement(CloseButton, { "data-testid": 'CHATBOT_POPOVER_CLOSEBUTTON', title: 'close', variant: 'filled', size: 'md', onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        onClose();
                    } })),
            React.createElement(Text, { fontSize: 1 }, text))));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=ChatBotPopOver.js.map